const PREPEND = "cookiedock";
const PREFERENCES = "__preferences";

export const CONSTANTS = {
  VERSION: "1.0.0",
  PREPEND: PREPEND,
  DEFAULT: {
    DATASET_NAME: "cuuid",
    SCRIPT_NAME: PREPEND,
    SCRIPT_ID: "data-cuuid",
    COOKIE_NAME: "cookiedock_consent",
  },
  CONSOLE: {
    TOO_MANY_SCRIPTS: `Too many ${PREPEND} scripts loaded`,
    NO_CUUID_FOUND: `No or incorrect cuuid found`,
    UNABLE_TO_INSERT_HTML: `Unable to insert dom before end of file`,
    UNABLE_TO_INSERT_CSS: `Unable to concat style inside the bundled file`,
    UNABLE_TO_FETCH_CONSENT: `Unable to fetch consent data from API`,
    NO_COOKIE_PURPOSES: `No cookie purposes found`,
  },
  BANNER: {
    SELECTOR: `__${PREPEND}`,
    HEADER: "--cdx-header",
    DESCRIPTION: "--cdx-description",
    PURPOSES: "--cdx-purposes",
    CONFIRM: "--cdx-confirm",
    DECLINE: "--cdx-decline",
    SETTINGS: "--cdx-settings",
    ACCEPT: "--cdx-accept",
    PREFIXED: {
      HEADER: "--cdx--header",
      DESCRIPTION: "--cdx--description",
      PURPOSES: "--cdx--purposes",
      CONFIRM: "--cdx--confirm",
      DECLINE: "--cdx--decline",
      SETTINGS: "--cdx--settings",
      ACCEPT: "--cdx--accept",
    },
  },
  DIALOG: {
    SELECTOR: `__${PREPEND}`,
    SAVE: "--cdx-save",
    CLOSE: "--cdx-close",
    CONTENT: "--cdx-content",
    PREFIXED: {
      SAVE: "--cdx--save",
      CLOSE: "--cdx--close",
      CONTENT: "--cdx--content",
    },
  },
  DETAILS: {
    SELECTOR: `__${PREPEND}`,
    CONTENT: "--cdx-content",
    HEADER: "--cdx-header",
    DESCRIPTION: "--cdx-description",
    PREFIXED: {
      CONTENT: "--cdx--content",
      HEADER: "--cdx--header",
      DESCRIPTION: "--cdx--description",
    },
  },
  PREFERENCES: {
    SELECTOR: `__${PREPEND}`,
    BANNER: `cdx-preferences-banner`,
    DIALOG: `cdx-preferences-dialog`,
  },
  TTL: {
    ONESECOND: 1,
    ONEMINUTE: 60,
    FIVEMINUTES: 60 * 5,
    TENMINUTES: 60 * 10,
    THIRTYMINUTES: 60 * 30,
    ONEHOUR: 60 * 60,
    TWOHOURS: 60 * 60 * 2,
    THREEHOURS: 60 * 60 * 3,
    FOURHOURS: 60 * 60 * 4,
    FIVEHOURS: 60 * 60 * 5,
    ONEDAY: 60 * 60 * 24,
    ONEMONTH: 60 * 60 * 24 * 30,
    ONEYEAR: 60 * 60 * 24 * 365,
  },
  CATEGORIES: {
    FUNCTIONAL: "functional",
    ANALYTICS: "analytics",
    MARKETING: "marketing",
    UNKNOWN: "unknown",
  },
  CHECK_CHANGES_INTERVAL: 5000,
  EVENTS_TO_TRACK: ["load", "DOMContentLoaded"],
  BLOCKED_TYPE_ATTRIBUTE: "blocked/javascript",
  TEXT_TYPE_ATTRIBUTE: "text/javascript",
  MODULE_TYPE_ATTRIBUTE: "module",
  STORAGENAME: `__${PREPEND}_storage`,
  CONTENT: `__${PREPEND}_content`,
  REJECTED: `__${PREPEND}_rejected`,
};
